const EN_US_LOCALE = 'en-US';
const FRACTIONAL_USD_EPSILON = 0.001;

export function formatUsdAmount(value: number): string {
  if (!Number.isFinite(value)) {
    throw new Error('USD price must be finite');
  }

  const hasFraction = Math.abs(value % 1) > FRACTIONAL_USD_EPSILON;

  return new Intl.NumberFormat(EN_US_LOCALE, {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: hasFraction ? 2 : 0,
  }).format(value);
}

export function formatUsd(value: number): string {
  return `US$ ${formatUsdAmount(value)}`;
}
